import React, { Component } from "react";
import ReactDOM from "react-dom";
import eventService from "../../services/eventService";
import slideShowService from "../../services/slideshowService";
import storageService from "../../services/storageService";
import AddChallengePromptComponent from "../addChallengePromptComponent/addChallengePrompt.component";
import { IChallengePDFConfig, IPDFConfig } from "../types/pdfConfig";
import DownloadPdfPromptComponent from "../downloadPdfPromptComponent/downloadPdfPrompt.component";
import DuplicatePdfPromptComponent from "../duplicatePdfPromptComponent/duplicatePdfPrompt.component";
import { IaddToPdfButtonProps } from "../types/props";
import { IaddToPdfButtonState } from "../types/states";
import "./addToPdfButtonComponent.scss";
import {EcartType} from "../enums";
class AddToPdfButtonComponent extends Component<
  IaddToPdfButtonProps,
  IaddToPdfButtonState
> {
  constructor(props: IaddToPdfButtonProps) {
    super(props);
    this.state = {
      addChallengepromptOpen: false,
      downloadPdfPromptOpen: false,
      duplicatePdfPromptOpen: false,
      disabled: false,
      speedBumpEnabled: storageService.speedBumpActive,
    };
  }

  componentDidMount() {
    eventService.on("pdf-app:add-disable", this.disable);
    eventService.on("pdf-app:add-enable", this.enable);
    eventService.on("modal-closed", this.modalClosed);
    eventService.on("modal-closing", this.modalClosing.bind(this));
  }

  componentWillUnmount() {
    eventService.off("pdf-app:add-disable", this.disable);
    eventService.off("pdf-app:add-enable", this.enable);
    eventService.off("modal-closed", this.modalClosed);
    eventService.off("modal-closing", this.modalClosing.bind(this));
  }

  render() {
    const portal = ReactDOM.createPortal(
      <div className={this.buttonContainerClasses()}>
        <button
          onClick={this.clickHandler}
          disabled={this.state.disabled}
          className={this.buttonClasses()}
          data-automation={"global-challenges-pdf-add-" + this.props.cartType}
        >
          <i>+ </i>
          {this.buttonText()}
        </button>
      </div>,
      document.getElementById("pdf-" + this.props.cartType)
    );
    return (
      <>
        {portal}
        {this.generateModalContent()}
      </>
    );
  }
  buttonText = () => {
    if(this.props.cartType === EcartType.challenge){
      return "Add to Your PDF";
    }
    return "Add Selection"
  };
  buttonClasses = () => {
    if (this.props.cartType === EcartType.challenge) {
      return "btn ampri-button-secondary pdf-add-challenge";
    }
    return "ampri-button-tertiary pdf-add-indexed " + (this.state.disabled == true ? 'disabled' : "");
  };

  buttonContainerClasses = () => {
    if (this.props.cartType === EcartType.challenge) {
      return "pdf-add-button-container";
    }
    // not defined in the scss file, but we need it for the z-index to work
    return "pdf-add-button-container-indexed";
  };

  disable = () => {
    this.setState({
      disabled: true,
    });
  };
  enable = () => {
    this.setState({
      disabled: false,
    });
  };

  modalClosing = (event) => {
    if (this.state.addChallengepromptOpen || this.state.downloadPdfPromptOpen) {
      event.preventDefault();
      this.setState({
        addChallengepromptOpen: false,
        downloadPdfPromptOpen: false,
        duplicatePdfPromptOpen: false,
      });
      //timeout required to ensure state is fully set before closing
      setTimeout(() => {
        slideShowService.hideModal();
      }, 1);
    }
  };
  modalClosed = () => {
    this.setState({
      addChallengepromptOpen: false,
      downloadPdfPromptOpen: false,
      duplicatePdfPromptOpen: false,
    });
  };
  generateModalContent = () => {
    if (this.state.addChallengepromptOpen)
      return (
        <AddChallengePromptComponent
          confirm={this.triggerOnClick}
          cancel={this.closeModel}
          promptEnabled={this.state.speedBumpEnabled}
        />
      );
    else if (this.state.downloadPdfPromptOpen) {
      return (
        <DownloadPdfPromptComponent
          confirm={this.openTray}
          cancel={this.closeModel}
        />
      );
    } 
    else if (this.state.duplicatePdfPromptOpen) {
      return (
        <DuplicatePdfPromptComponent
          confirm={this.closeModel}
        />
      );
    } else return null;
  };
  openTray = () => {
    this.closeModel();
    this.props.openTray();
  };
  clickHandler = async (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.stopPropagation();
    // If indexed cart, we want to check for dupes.
    if (this.props.cartType == EcartType.indexed) {
      var indexedPDFConfigs = storageService.indexedPDFConfigs;
      var duplicate = [];
      await slideShowService.currentChapterController
        .getPDFConfig()
        .then((pdfConfig: IChallengePDFConfig[]) => {
          duplicate = indexedPDFConfigs.filter((config) => {
            return pdfConfig.some(function (config2) {
              return config.meta.protection === config2.meta.protection &&
                config.meta.category === config2.meta.category &&
                config.meta.segment === config2.meta.segment &&
                config.meta.index === config2.meta.index &&
                config.meta["surrender-schedule"] === config2.meta["surrender-schedule"] &&
                config.name === config2.name;
            });
          });
        });
      if (duplicate.length > 0) {
        slideShowService.showModal('<div id="pdf-duplicate--modal"></div>');
        this.setState({
          duplicatePdfPromptOpen: true,
        });
        return;
      }
    }
    
    if (this.props.requireDownload) {
      slideShowService.showModal('<div id="pdf-download--modal"></div>');
      this.setState({
        downloadPdfPromptOpen: true,
      });
      return;
    }
    if (this.state.speedBumpEnabled) {
      slideShowService.showModal('<div id="pdf-challenge--modal"></div>');
      this.setState({
        addChallengepromptOpen: true,
      });
    } else {
      this.triggerOnClick();
    }
  };
  closeModel = () => {
    this.setState({
      addChallengepromptOpen: false,
      downloadPdfPromptOpen: false,
      duplicatePdfPromptOpen: false,
    });
    slideShowService.hideModal();
  };
  triggerOnClick = (disableModalSpeedBump?: boolean) => {
    if (this.props.onClick) {
      this.props.onClick();
      this.closeModel();
    }
    if (disableModalSpeedBump) {
      this.setState({
        speedBumpEnabled: false,
      });
      storageService.speedBumpActive = false;
    }
  };
}

export default AddToPdfButtonComponent;
